//basic
import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'

//style
import './ProductShopsManagement.scss'

//api
import { api } from '../../functions/api'
import { debounce } from 'lodash'
import { ProductLink } from './ProductLink'
import CircularProgress from '@material-ui/core/CircularProgress'
import Search from '../../components/basic/search'
import Icon from '@mdi/react'
import { mdiRocket } from '@mdi/js'
import CustomButton from '../../components/basic/CustomButton'

//custom components

@inject('internal')
@inject('translate')
@observer
export default class ProductShopsManagement extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      launching: false,
      errorMessage: '',
      searchTerm: '',
      removing: [],
      saving: [],
      items: [],
      newLink: {
        id: null,
        link: ''
      }
    }
  }

  componentDidMount() {
    this.props.internal.setRoute(this.props.history, this.props.location.pathname)
    this.props.internal.setHeaderTitle(this.props.translate.i18n.MODULES.PRODUCT_SHOPS_MANAGEMENT.TITLE)
    this.load()
  }

  load = debounce(() => {
    this.setState({loading: true}, () => {

      api({
        method: 'get',
        url: 'lists/monitored-product-shops',
        authorization: this.props.internal.user.access_token,
        params: {
          searchTerm: this.state.searchTerm
        }
      }).then(result => {
        if (! result.success) {
          this.setState({ errorMessage: result.data.data.message })
          return
        }

        this.setState({ items: result.data.data, loading: false })
      })
    })
  }, 650)

  handleLinkStore = debounce((product_id, id, link) => {
    const { saving } = this.state
    if (! this.isProductLinkBeingSaved(product_id, id)) {
      saving.push({ product_id, link_id: id})
    }

    this.setState({
      saving,
      newLink: {
        updated_at: Date.now(),
        link: id ? '' : link
      }
    }, () => {
      api({
        method: 'patch',
        url: 'lists/monitored-product-shops/link',
        authorization: this.props.internal.user.access_token,
        params: {
          product_id,
          link
        }
      }).then(result => {
        const { saving, items } = this.state

        if (result.success) {
          const index = items.findIndex(p => p.id === result.data.data.id)
          if (index > -1) {
            items.splice(index, 1, result.data.data)
          } else {
            items.splice(0, 0, result.data.data)
          }
        } else {
          this.props.internal.setSnackbar(result.data.message, true, true, 5000)
        }

        this.setState({
          saving: saving.filter(i => ! (i.product_id === product_id && i.link_id === id)),
          items,
          newLink: {
            id: null,
            link: ''
          }
        })
      })
    })
  }, 650)

  handleDeleteLink = (product_id, id) => {
    const { removing } = this.state
    if (! this.isProductLinkBeingRemoved(product_id, id)) {
      removing.push({ product_id, link_id: id})
    }

    this.setState({
      removing,
    }, () => {
      api({
        method: 'delete',
        url: 'lists/monitored-product-shops/link',
        authorization: this.props.internal.user.access_token,
        params: {
          product_id,
          id
        }
      }).then(result => {
        const { removing, items } = this.state

        if (result.success) {
          const index = items.findIndex(p => p.id === result.data.data.id)
          if (index > -1) {
            items.splice(index, 1, result.data.data)
          } else {
            items.splice(0, 0, result.data.data)
          }
        } else {
          this.props.internal.setSnackbar(result.data.message, true, true, 5000)
        }

        this.setState({
          removing: removing.filter(i => ! (i.product_id === product_id && i.link_id === id)),
          items,
        })
      })
    })
  }

  launchMonitoring = () => {
    this.setState({launching: true}, () => {
      api({
        method: 'put',
        url: 'lists/monitored-product-shops/launch',
        authorization: this.props.internal.user.access_token,
      }).then(result => {
        if (! result.success) {
          this.props.internal.setSnackbar(result.data.message, true, true, 5000)
          return
        }

        this.props.internal.setSnackbar(result.data.message, true, false, 5000)
        this.setState({ launching: false })
      })
    })
  }

  handleSearch = (searchTerm) => {
    this.setState({
      searchTerm
    }, () => this.load())
  }

  isProductLinkBeingSaved = (product_id, link_id) => {
    return this.state.saving.some(i => i.product_id === product_id && i.link_id === link_id)
  }

  isProductLinkBeingRemoved = (product_id, link_id) => {
    return this.state.removing.some(i => i.product_id === product_id && i.link_id === link_id)
  }

  render() {
    const { items, newLink, loading, launching } = this.state

    return (
      <div className={'max-h-100vh-100px mt-10'}>
        <div className={'products-action'}>
          <Search placeholder={this.props.translate.i18n.MODULES.PRODUCTS.SEARCH} classes={'products-search-box'} onChange={this.handleSearch} value={this.state.searchTerm }/>
          <div>
            <CustomButton
              disabled={launching}
              mystyle={'btn-orange-bg border-radius-18 category'}
              title={this.props.translate.i18n.MODULES.PRODUCT_SHOPS_MANAGEMENT.LAUNCH_MONITORING}
              onClick={this.launchMonitoring}
            >
              {launching ? (<CircularProgress className={'circular-progress mini white'} />) : (<Icon path={mdiRocket} size={1}/>)}
            </CustomButton>
          </div>
        </div>
        {loading ? (
          <CircularProgress className={'circular-progress'}/>
        ) : (
          <div className={'products-list-wrapper'}>
            {items.map(product => (
              <div key={product.id} className={'product-card'}>
                <div className={'product-header'}>{product.code} - {product.name}</div>
                <div className={'product-links'}>
                  <ProductLink
                    product={product}
                    link={newLink}
                    saving={this.isProductLinkBeingSaved(product.id, null)}
                    inputLabel={this.props.translate.i18n.MODULES['PRODUCTS'].MONITORING.NEW_LINK}
                    handleLinkUpdate={this.handleLinkStore}
                  />
                  {product.monitored_links.map(link => (
                    <ProductLink
                      key={link.id}
                      product={product}
                      link={link}
                      saving={this.isProductLinkBeingSaved(product.id, link.id)}
                      removing={this.isProductLinkBeingRemoved(product.id, link.id)}
                      inputLabel={this.props.translate.i18n.MODULES['PRODUCTS'].MONITORING.LINK}
                      updatedTodayLabel={this.props.translate.i18n.MODULES.PRODUCT_SHOPS_MANAGEMENT.UPDATED_TODAY_LABEL}
                      monitoringErrorLabel={this.props.translate.i18n.MODULES.PRODUCT_SHOPS_MANAGEMENT.MONITORING_ERROR_LABEL}
                      handleDeleteLink={this.handleDeleteLink}
                      handleLinkUpdate={this.handleLinkStore}
                    />
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}

      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/screens/ProductShopsManagement/ProductShopsManagement.jsx